import type { IIframeInterface } from '~/modules/iframes/Iframe';

/**
 * Base communication listener class to extend
 */
export abstract class Listener {
  protected widgetObject: IIframeInterface | IIframeInterface[];

  constructor(iframe: IIframeInterface | IIframeInterface[]) {
    this.widgetObject = iframe;
  }

  /**
   * Widget messages listener
   * NOTE: We need to use arrow function here to bind function to this object instead of the event.
   * @param {any} event - message event
   */
  protected abstract listener: (event: any) => void;

  /**
   * 🔧 Simple util to verify event
   * @param {any} event - Message event to verify
   * @returns {boolean}
   */
  protected isValidEvent(event: any): boolean {
    // Ensure the event structure is correct
    if (!(event instanceof Object) && !(event.data instanceof Object) && !event.data.sourceWindowName) {
      return false;
    }

    // Ensure that iframe window name matches with the iframe name of the message listener
    let matchesIframe: boolean = false;
    if (!Array.isArray(this.widgetObject)) {
      matchesIframe = event.data.sourceWindowName === this.widgetObject.iframe.name;
    } else {
      for (let iframeInterface of this.widgetObject) {
        if (iframeInterface.iframe.name === event.data.sourceWindowName) {
          matchesIframe = true;
        }
      }
    }
    return matchesIframe;
  }

  /**
   * Post message to the iframe
   * @param data
   */
  public postMessage(data: any): void {
    if (Array.isArray(this.widgetObject)) {
      this.widgetObject.forEach((element) => {
        element.onLoad((iframeWindow) => iframeWindow.postMessage(data, '*'));
      });
    } else {
      this.widgetObject.onLoad((iframeWindow) => iframeWindow.postMessage(data, '*'));
    }
  }

  /**
   * Remove attached communication listener
   */
  public removeMessageListener() {
    window.removeEventListener('message', this.listener);
  }
}
